import posthog from "posthog-js";

/* -------------------------------------------------------------------------- */
/* PostHog wrapper — every function is a safe no-op when analytics is         */
/* unconfigured (empty POSTHOG_KEY) or init failed. Components must import    */
/* from this module only, never posthog-js directly.                          */
/* -------------------------------------------------------------------------- */

let ready = false;

export function initAnalytics(key, host, { tenant } = {}) {
  if (!key) return;
  try {
    posthog.init(key, {
      api_host: host || "https://eu.i.posthog.com",
      ui_host: "https://eu.posthog.com",
      person_profiles: "identified_only",
      capture_pageview: true,
      session_recording: {
        maskAllInputs: true,
        // The /api/llm-agent request body carries credentials — never record
        // network payloads into session replay.
        recordHeaders: false,
        recordBody: false,
      },
    });
    if (tenant) posthog.register({ tenant });
    ready = true;
  } catch (error) {
    console.error("Analytics init failed:", error);
  }
}

export function identifyUser(username, { tenant } = {}) {
  if (!ready || !username) return;
  try {
    // Tenant-prefixed distinct_id: the same username in two tenants must not
    // merge into one person.
    posthog.identify(`${tenant}:${username}`, { username, tenant });
    if (tenant) posthog.group("tenant", tenant);
  } catch {}
}

export function capture(event, props) {
  if (!ready) return;
  try {
    posthog.capture(event, props);
  } catch {}
}
